module.exports = __webpack_public_path__ + "img/lala_scroll07.9e149279.webp";